import React from "react";
import CreateDocument from "../Components/DocumentCrafting/Create/CreateDocument";

const DocumentCraftingCreatePage: React.FC = () => <CreateDocument />;

export default DocumentCraftingCreatePage;
